<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          首级集成商名称：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="integrator">
            <el-select
              ref="integrator"
              v-model="integrator"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
              style="width:100%;"
              value-key="agentID"
              @change="change"
            >
              <el-option
                v-for="item in list"
                :key="item.agentID"
                :label="item.agentName"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          首级集成商类型：
        </div>
        <div class="rj-baseinfo__item">
          {{ form.integratorType }}
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getIntAll } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      loading: false,
      integrator: ''
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getIntAll(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      this.form.integratorName = val.agentName;
      this.form.integratorCode = val.agentID;
      this.form.integratorType = val.agentTypeName;
    },
    initData () {
      if (this.form.integratorCode) {
        this.list = [{
          agentName: this.form.integratorName,
          agentTypeName: this.form.integratorType,
          agentID: this.form.integratorCode
        }];
        this.integrator = {
          agentID: this.form.integratorCode
        };
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="less"></style>
